import PropTypes from 'prop-types';
import React from 'react';
import Styled from './pill-component-style';

/**
 * Pill component
 * @param {object} root0 - root object
 * @param {Function} root0.onDelete - delete handler
 * @param {string} root0.type - style overrides
 * @param {object} root0.style - style overrides
 * @param {string} root0.label - style overrides
 * @returns {React.ReactElement} React component
 */
const Pill = ({ onDelete, style, type = null, label }) => {
  const getColor = (t) => {
    switch (t?.toLowerCase()) {
      case 'user':
        return 'purple';
      case 'dealer':
      case 'draft':
      case 'company':
      case 'default':
        return 'blue';
      case 'supplier':
        return 'green';
      case 'create':
      case 'read':
      case 'update':
      case 'delete':
        return 'red';
      case 'supplierlabel':
        return 'black';
      default:
        return 'default';
    }
  };

  return (
    <Styled.Pill
      style={style}
      color={(type && getColor(type)) ?? (label && getColor('supplierlabel'))}
    >
      {onDelete && (
        <Styled.DeleteButton
          type="button"
          className="delete-button"
          onClick={onDelete}
        >
          &times;
        </Styled.DeleteButton>
      )}
      <span>{type ?? label}</span>
    </Styled.Pill>
  );
};

Pill.defaultProps = {
  type: null,
  label: null,
  onDelete: null,
  style: {},
};

Pill.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string,
  onDelete: PropTypes.func,
  style: PropTypes.shape({}),
};

export default Pill;
